import ConfigData from './AppConfig.json';
import DeathReportModule from '../modules/members/deathReport/DeathReportModule';
import CaseStatusModule from '../modules/members/caseStatus/CaseStatusModule';
import LovModule from '../modules/utility/lov/LovModule';
import SecureFileUploadModule from '../modules/members/secureFileUpload/SecureFileUploadModule';
import { makeAutoObservable, observable } from 'mobx';
import ReleaseNoteModule from '../modules/utility/releaseNote/ReleaseNoteModule';
import SraModule from '../modules/members/ora/OraModule';
import SpcModule from '../modules/members/spc/SpcModule';
import RetirementCalcModule from '../modules/members/retirementCalculator/RetirementCalcModule';

export interface ISetting {
  AppVersion: string;
  EnvironmentName: string;
  UseModelDialogForEdits: boolean;
  GridPageSize: number;
  AllowedFileExtensions: string;
  AllowedFileSizeBytes: number;
  CaptchaSiteKey: string;
  PdfSiteKey: string;
  MyScersPortalUrl: string,
  IdleTimeoutSeconds: number;
  IdlePromptTimeoutSeconds: number;
  IdleTimeourtExcludeRoutes: Array<string>;
  Services: {
    MemberServiceUrl?: string;
    RetirementServiceUrl?: string;
    UtilityServiceUrl?: string;
    IdentityServiceUrl?: string;
    PurchaseCalculatiorUrl?: string;
    BeneverseServiceUrl?: string;
  }
  AuthProviders?: [
    {
      Provider: string;
      ClientId?: string;
      AuthorityUrl?: string;
      UserInfoUrl?: string;
      LoginRedirectUrl?: string;
      LogoutUrl?: string;
      Scopes: Array<string>;
      UserAttributes: {
        DisplayName?: string;
        UserId?: string;
        Email?: string;
      }
    }
  ];
}

export class AppConfig {
  private static _instance: AppConfig;
  public static get instance() {
    return this._instance ?? (this._instance = new AppConfig());
  }

  @observable public Setting?: ISetting;

  constructor() {
    let envName = this.getEnvironment();
    this.Setting = ConfigData.Setting.find(o => o.EnvironmentName === envName) as ISetting;
    this.Setting.AppVersion = "0.0.6";
    makeAutoObservable(this);
  }

  private getEnvironment(): string {
    let env = 'local';
    const location = window.location.host.toLowerCase();
    if (location.includes('localhost')) {
      env = 'local';
    } else if (location.includes('agreeable-hill')) {
      env = 'qual';
    }
    else if (location.includes('test.scers')) {
      env = 'test';
    } else {
      env = 'prod';
    }
    // env = 'qual';
    return env;
  }

  public async getReleaseInfo(): Promise<string> {
    let releaseInfo = `Build#: 1.0.0 - Date: 00/00/0000`
    const versionInfoUrl = `${this.Setting?.Services.UtilityServiceUrl}/utility/release-notes/latest-release`
    const request = new Request(versionInfoUrl, {
      method: "GET",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    let resposne = await fetch(request);
    if (resposne.ok) {
      let data = await resposne.json();
      releaseInfo = `Build: ${data?.buildNbr} - Date: ${data?.buildDate}`
      if (data.envName === "prod") {
        return releaseInfo;
      } else {
        return `${releaseInfo} (${data.envName.toUpperCase()})`;
      }
    }
    return releaseInfo;
  }

  public static init(): void {
    LovModule.init();
    SecureFileUploadModule.init();
    DeathReportModule.init();
    ReleaseNoteModule.init();
    SraModule.init();
    SpcModule.init();
    CaseStatusModule.init();
    RetirementCalcModule.init();
  }
}